import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// config
import { defaultLang } from '../config/config';
//
import enLocales from './en';
import frLocales from './fr';
import arLocales from './ar';
import esLocales from './es';
import ptLocales from './pt';
import grLocales from './gr';
import itLocales from './it';
import backendEn from './backend/en';
import backendFr from './backend/fr';
import backendAr from './backend/ar';
import backendEs from './backend/es';
import backendPt from './backend/pt';
import backendGr from './backend/gr';
import backendIt from './backend/it';
import { documentationEN, documentationES, documentationFR, documentationIT, documentationPT } from './documentation';

// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: { ...enLocales, ...backendEn, ...documentationEN } },
      fr: { translations: { ...frLocales, ...backendFr, ...documentationFR } },
      ar: { translations: { ...arLocales, ...backendAr } },
      es: { translations: { ...esLocales, ...backendEs, ...documentationES } },
      pt: { translations: { ...ptLocales, ...backendPt, ...documentationPT } },
      gr: { translations: { ...grLocales, ...backendGr } },
      it: { translations: { ...itLocales, ...backendIt, ...documentationIT } },
    },
    lng: localStorage.getItem('i18nextLng') || defaultLang.value,
    fallbackLng: defaultLang.value,
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
